import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import StyledTags from './Tags.style.js';

const Tags = ({
  accentColor,
  className,
  horizontal,
  tags,
  variant
}) => /*#__PURE__*/React$1.createElement(StyledTags, {
  accentColor: accentColor,
  className: className,
  horizontal: horizontal,
  variant: variant
}, tags && tags.length > 0 && tags.map(({
  id,
  title,
  slug
}) => slug ? /*#__PURE__*/React$1.createElement(Link$1, {
  className: "tags__tag",
  noHover: true,
  label: title,
  href: {
    pathname: '/tag',
    query: {
      slug
    }
  },
  asPath: `/tag/${slug}`
}, /*#__PURE__*/React$1.createElement(Typography$1, {
  key: id || title,
  variant: variant
}, title)) : /*#__PURE__*/React$1.createElement(Typography$1, {
  key: id || title,
  variant: variant,
  className: "tags__tag"
}, title)));

Tags.propTypes = {
  accentColor: PropTypes$1.string,
  className: PropTypes$1.string,
  horizontal: PropTypes$1.bool,
  tags: PropTypes$1.arrayOf(PropTypes$1.shape({
    title: PropTypes$1.string,
    id: PropTypes$1.string
  })).isRequired,
  variant: PropTypes$1.oneOf(['intro', 'small'])
};
Tags.defaultProps = {
  accentColor: '',
  className: '',
  horizontal: false,
  variant: 'small'
};

export default Tags;
